import axios, { AxiosResponse } from "axios"
import { DireccionCreationDtoProps } from "./DTOs/DireccionCreationDto"

export async function postDireccion(
  direccion: DireccionCreationDtoProps
): Promise<AxiosResponse> {
  const resp = await axios.post("/Direccion", direccion)
  return resp
}
